/**
 * Created by Ganesh.Sharma on 27-08-2016.
 */

define([

        'customerEdge/addressstandardization/directives/StandardAddress',
        'customerEdge/addressstandardization/directives/OwnershipAddress',
        'customerEdge/addressstandardization/services/AddressStandardizationService'

    ],
    ( StandardAddress, OwnershipAddress, AddressStandardizationService) => {
    return angular.module('customerEdge.addressstandardization.app', [])

        .directive('gwPlStandardAddress', StandardAddress)
        .directive('gwPlOwnershipAddress', OwnershipAddress)
        .factory('AddressStandardizationService', AddressStandardizationService);
}
);




/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/addressstandardization/app.js
 **/